class RequestTrackerService {
  private requestCount: number = 0;

  constructor() {}

  public startRequest() {
    this.requestCount++;
  }

  public endRequest() {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
  }

  public isRequestInProgress() {
    return this.requestCount > 0;
  }
}

export default new RequestTrackerService();
